import React from 'react';
import dynamic from 'next/dynamic';

import PasscodeForm from 'components/publicWebsiteV2/pages/Passcode/PasscodeForm';
import NamesModule from 'components/publicWebsiteV2/common/NamesModule';

import { useWebsiteThemeContext } from 'components/publicWebsiteV2/context';
import InViewWrapper from 'components/common/InViewWrapper/InViewWrapper';

import { StyledContentContainerComponent } from './Passcode.styles';

const Footer = dynamic(() => import('../../common/Footer'), {
  ssr: false,
});

const Passcode = (): JSX.Element => {
  const {
    state: { wedding },
  } = useWebsiteThemeContext();
  const { owner_first_name, owner_last_name, partner_first_name, partner_last_name } =
    wedding || {};

  return (
    <StyledContentContainerComponent>
      <NamesModule
        ownerFirstName={owner_first_name}
        ownerLastName={owner_last_name}
        partnerFirstName={partner_first_name}
        partnerLastName={partner_last_name}
        textAlignment="CENTER"
      />
      <PasscodeForm />
      <InViewWrapper>
        <Footer />
      </InViewWrapper>
    </StyledContentContainerComponent>
  );
};

export default Passcode;
